import _ from 'lodash';
import route from "../../router";
import moment from "../../plugins/moment";
import { mapGetters, mapActions } from "vuex";
import { GET_LOADING } from "../../store/getter-types";
import * as BOOKING_GETTERS from "../../store/booking/getter-types";
import * as DESTINIES_GETTERS from "../../store/destinies/getter-types";
import * as DESTINIES_ACTIONS from "../../store/destinies/action-types";
import * as BOOKING_ACTIONS from "../../store/booking/action-types";
import searcherMixin from "../../modules/searcher/mixins/searcherMixin";

export default {
  mixins: [searcherMixin],
  data: () => ({
    itemsLoaded: false,
    items: [],
    // showSearchForm: route.currentRoute.params.origin
  }),
  computed: {
    ...mapGetters({
      loading: GET_LOADING,
      booking: BOOKING_GETTERS.GET_BOOKING,
      destinies: DESTINIES_GETTERS.GET_DESTINIES,
      originsOptions: DESTINIES_GETTERS.GET_ORIGINS_OPTIONS,
      destiniesImages: DESTINIES_GETTERS.GET_DESTINIES_IMAGES
    })
  },
  created() {
    this.handleFetchData();
    this.showSearchForm();
  },
  beforeRouteUpdate(to, from, next) {
    next();
    this.handleFetchData(to.params.origin);
  },
  methods: {
    ...mapActions({
      fetchPlaces: DESTINIES_ACTIONS.FETCH_PLACES,
      fetchDestinies: DESTINIES_ACTIONS.FETCH_DESTINIES
    }),
    showSearchForm() {
      if (route.currentRoute.params.origin) {
        return true;
      } else {
        return false;
      }

    },
    handleFetchData(originCode) {
      if (route.currentRoute.params.origin) {
        if (
          this.origin &&
          this.searchValues.travellers.adults > 0 &&
          this.searchValues.date
        ) {
          // Cuándo
          this.handleFetchDestinies(originCode);
        } else {
          this.fetchPlaces()
            .then(() => {
              const selectedOrigin = this.originsOptions.find(
                location => location.code === route.currentRoute.params.origin
              );
              if (selectedOrigin) {
                this.handleSelectLocation(selectedOrigin.code);
                const travellers = {
                  adults: parseInt(route.currentRoute.query.adults[0]),
                  childs: route.currentRoute.query.childs[0]
                    ? parseInt(route.currentRoute.query.childs[0])
                    : 0,
                  babies: route.currentRoute.query.babies[0]
                    ? parseInt(route.currentRoute.query.babies[0])
                    : 0
                };
                this.setTravellers(travellers)
                  .then(() => {
                    this.handleSetDate();
                    this.handleFetchDestinies();
                  })
                  .catch(err => {
                    this.$toastr.e(
                      window.i18n.t('toast.error_6')
                    );
                  });
              } else {
                this.$toastr.e(
                  window.i18n.t('toast.error_7')
                );
                route.push({ name: "home-when" });
              }
            })
            .catch(() => {
              this.$toastr.e(
                window.i18n.t('toast.error_3')
              );
            });
        }
      } else {
        // Destinos de un día
        this.handleFetchDestinies();
      }
    },
    handleSetDate() {
      const date = moment(route.currentRoute.query.fecha, "DD-MM-YYYY");
      this.setSearchDate(date);
    },
    handleFetchDestinies(originCode) {
      let params = {};
      if (route.currentRoute.params.origin) {
        params = {
          origin: originCode || route.currentRoute.params.origin,
          date: moment(this.parsedDate, "DD-MM-YYYY").format(
            "YYYY-MM-DD"
          ),
          adults: route.currentRoute.query.adults,
          children: route.currentRoute.query.childs,
          babies: route.currentRoute.query.babies
        };
      }
      this.fetchDestinies(params)
        .then(() => {
          if (this.destinies.flights.length > 0) {
            this.parseDestiniesResults(this.destinies.flights);
            this.itemsLoaded = true;
          } else {
            this.items = [];
            this.itemsLoaded = true;
          }
        })
        .catch(error => {
          console.log(error);

          this.$toastr.e(
            window.i18n.t('toast.error_3')
          );
          route.push({ name: "home-when" });
        });
    },
    parseDestiniesResults(results) {
      if (route.currentRoute.params.origin) {
        const items = results.map(result => {
          const resultImage = this.destiniesImages[result.airportTo];
          return {
            image: resultImage
              ? resultImage
              : "/img/card-blog.jpg",
            title: result.cityTo,
            price: result.price,
            link: "",
            cityCodeTo: result.cityCodeTo,
          };
        });
        this.items = _.sortBy(items, ['price']);
      } else {
        this.items = results;
      }
    },
    handleSelectTrip(cityCodeTo) {
      const selectedFlight = this.destinies.flights.find(flight => flight.cityCodeTo == cityCodeTo);;

      if (route.currentRoute.params.origin) {
        const booking = {
          departureToken: selectedFlight.departureToken,
          travellerPrice: parseFloat(selectedFlight.price),
          travellers: {
            adults: {
              total: parseInt(route.currentRoute.query.adults),
              data: {}
            },
            childs: {
              total: parseInt(route.currentRoute.query.childs),
              data: {}
            },
            babies: {
              total: parseInt(route.currentRoute.query.babies),
              data: {}
            }
          },
          outgoingFlight: {
            departure: {
              code: this.$route.params.origin,
              airport: selectedFlight.airportFrom,
              name: selectedFlight.cityCodeFrom,
              datetime: moment(
                selectedFlight.journeyFlightDepartureTime,
                "YYYY-MM-DDTHH:mm:ss"
              )
            },
            arrival: {
              code: this.$route.params.destiny,
              airport: selectedFlight.airportTo,
              name: selectedFlight.cityCodeTo,
              datetime: moment(
                selectedFlight.journeyFlightArrivalTime,
                "YYYY-MM-DDTHH:mm:ss"
              )
            }
          },

          airlines: selectedFlight.airlines
        };
        this.$store
          .dispatch(BOOKING_ACTIONS.SET_BOOKING, booking)
          .then(() => {
            const origin = this.booking.outgoingFlight.departure.name;
            const destiny = this.booking.outgoingFlight.arrival.name;
            const dateOfFlight = this.booking.outgoingFlight.departure.datetime.format(
              "DD-MM-YYYY"
            );

            this.$router.push({
              name: "checkout",
              params: {
                step: "detalles"
              },
              query: {
                origen: origin,
                destino: destiny,
                airlines: 'FR',
                adults: this.booking.travellers.adults.total,
                childs: this.booking.travellers.childs.total,
                babies: this.booking.travellers.babies.total,
                fecha: dateOfFlight,
                precio: this.totalPrice,
                departureToken: this.booking.departureToken
              }
            });
          })
          .catch(error => {
            this.$toastr.e(window.i18n.t('toast.error_8'));
          });
      } else { // Destinos de un día
        const { slug } = selectedFlight;
        route.push({ name: "destiny", params: { slug } });
      }
    }
  }
};
